import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'shared-components';

const ReduxField = ({ meta, input, ...props }) => (
  <Field {...{ ...props, ...input, invalid: meta.touched && !!meta.error, error: meta.error }} />
  );

ReduxField.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ReduxField;



// WEBPACK FOOTER //
// ./src/components/organisms/ReduxField/index.js